export default "/images/45930e7adc058ce0374444d006b52a99.png";